<template>
	<v-container>
		<v-card flat>
			<v-card-title class="text-h4">Тарифи</v-card-title>
			<v-card-text>
				<v-row>
					<!-- <v-col cols="12" :md="items.length < 3 ? 0 : 6" v-for="(item, index) in items" :key="index"> -->
					<v-col cols="12" md="4" v-for="(item, index) in items" :key="index">
						<v-card>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">Тариф</div>
									<v-list-item-title class="text-h5 mb-1">{{ item.name }}</v-list-item-title>
									<v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-divider></v-divider>

							<v-list>
								<v-list-item>
									<v-list-item-icon>
										<v-icon>mdi-file-search</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Запитів/міс</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-list-item-action-text>{{ item.requestCount }}<span v-if="item.code=='Enterprise'">+</span></v-list-item-action-text>
									</v-list-item-action>
								</v-list-item>
								<v-list-item>
									<v-list-item-icon>
										<v-icon>mdi-account-group</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Користувачів</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-list-item-action-text>{{ item.userCount }}<span v-if="item.code=='Enterprise'">+</span></v-list-item-action-text>
									</v-list-item-action>
								</v-list-item>
								<v-list-item>
									<v-list-item-icon>
										<v-icon>mdi-laptop</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Вартість додаткового місця</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-list-item-action-text>{{ item.pricePalce }}<span v-if="item.code=='Enterprise'">+</span></v-list-item-action-text>
									</v-list-item-action>
								</v-list-item>
								<v-list-item>
									<v-list-item-icon>
										<v-icon>mdi-package-variant</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Вартість пакету</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-list-item-action-text>{{ item.price }}<span v-if="item.code=='Enterprise'">+</span></v-list-item-action-text>
									</v-list-item-action>
								</v-list-item>
							</v-list>

							<!-- <v-card-text>
								<v-subheader>REPORTS</v-subheader>
								<v-chip-group active-class="deep-purple accent-4 white--text" column>
									<v-chip>{{ item.price }} грн.</v-chip>
								</v-chip-group>
							</v-card-text> -->
						</v-card>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12" md="3">
						<v-card>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">Тариф</div>
									<v-list-item-title class="text-h5 mb-1">Розразунок</v-list-item-title>
									<!-- <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle> -->
								</v-list-item-content>
							</v-list-item>
							<v-divider></v-divider>
							<v-card-text>
								<v-combobox
									v-model="calculate.services"
									:items="services"
									label="Сервіси"
									item-text="shortTitle"
									multiple
								></v-combobox>
								<v-text-field
									v-model="calculate.requestCount"
									label="Запитів/міс"
									prepend-inner-icon="mdi-file-search"
									type="number"
									:min="1000"
								></v-text-field>
								<v-text-field
									v-model="calculate.userCount"
									label="Користувачів"
									prepend-inner-icon="mdi-account-group"
									type="number"
									:min="1"
								></v-text-field>

								<v-chip-group
									active-class="deep-purple accent-4 white--text"
									column
								>
									<v-chip>{{ calculate.price }} грн.</v-chip>
								</v-chip-group>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

		
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Tariff',
	data: () => ({
		items: [
			{ code: 'Start', name: 'Start', description: '', requestCount: 1000, userCount: 1, pricePalce: 400, price: 5000 },
			{ code: 'Team', name: 'Team', description: '', requestCount: 2000, userCount: 5, pricePalce: 250, price: 10000 },
			{ code: 'Business', name: 'Business', description: '', requestCount: 5000, userCount: 20, pricePalce: 200, price: 17000 },
			{ code: 'Enterprise', name: 'Enterprise', description: '', requestCount: 5000, userCount: 20, pricePalce: 200, price: 17000 },

/*
Оцінка ТЗ 2 000 5 місць 400,00 10 000,00
Оцінка ТЗ-3 3 000 10 місць 350,00 12 000,00
Оцінка ТЗ-4 4 000 15 місць 300,00 14 000,00
Оцінка ТЗ-5 5 000 20 місць 250,00 17 000,00
Оцінка ТЗ-6 6 000 30 місць 200,00 20 000,00
Оцінка ТЗ-10 10 000 40 місць 150,00 25 000,00
Оцінка ТЗ-20 20 000 50 місць 100,00 35 000,00
Оцінка ТЗ-50 50 000 60 місць 50,00 45 000,00

Індивідуальний
понад  50 000
безлімітне 0,00 індивід
*/

/* 
Тариф		Запитів/міс	Користувачів	Ціна (USD)
Start		10 000		1				$29
Team		50 000		до 5			$79
Business	100 000		до 20			$149
Enterprise	250 000+	20+	custom 
*/
		],

		select: [],

		calculate: {
			services: [],
			requestCount: null,
			userCount: null,
			price: null,
		}
	}),
	
	computed: {
		...mapGetters([ 'holder', 'authorized', 'profile', 'services' ]),
		/* to() {
			//console.log(this.router)

			return {name: this.router}
		} */
		/* image() {
			if(this.item.image) {
				//return process.env.VUE_APP_URL + process.env.VUE_APP_PROFILES_UPLOADS+'/'+this.item.image;
				return this.item.image
			} else {
				return require('../assets/drug.png')
			}
		}, */
	},
	watch: {
		
	},
	methods: {
	
	},
}
</script>